// extracted by mini-css-extract-plugin
module.exports = {"beautySimplification":"Breadcrumbs_beautySimplification__lcmh5","breadcrumbsSpacer":"Breadcrumbs_breadcrumbsSpacer__pHrmD"};